import LinkStyle from './link-style';
import Node from './node';

export default class Action extends Node {
	/* @ngInject */
	/**
	 * Instantiates an Action on the WF
	 *
	 * @name app.Action
	 * @class
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('@knitiv/api-client-javascript').KNode | undefined} kid
	 */
	constructor(
		$injector,
		kid = undefined,
	) {
		super($injector, kid, 'K_NODE;WF_ACTION');

		Object.defineProperty(this, '__', { value: {} });

		/** @type {boolean} */
		this.affectAuto = false;

		/** @type {import('@knitiv/api-client-javascript').KNode[]} */
		this.allocators = [];

		/** @type {boolean} */
		this.commentRequired = false;

		/** @type {boolean} */
		this.enableTargetStateAllocators = false;

		/**
		 * Element identifier
		 *
		 * @type {string | undefined}
		 */
		this.id = undefined;

		/**
		 * Link identifier (KLINK;xxx)
		 *
		 * @type {string | undefined}
		 * @deprecated
		 */
		this.klink = undefined;

		/** @type {boolean} */
		this.notify = true;

		/** @type {boolean} */
		this.notifyInitiator = false;

		/** @type {boolean} */
		this.selected = false;

		/**
		 * Shape of the action
		 *
		 * @type {string}
		 */
		this.shape = 'ELLIPSIS';

		/**
		 * States listed as FROM this action
		 *
		 * @type {Record<import('@knitiv/api-client-javascript').KNode, any>}
		 */
		this.statefrom = {};

		/**
		 * States listed as TO this action
		 *
		 * @type {Record<import('@knitiv/api-client-javascript').KNode, any>}
		 */
		this.stateto = {};

		/**
		 * Style of the action
		 *
		 * @type {LinkStyle}
		 */
		this.style = new LinkStyle();

		/**
		 * Shows or hide the DOM element on designer
		 *
		 * @type {boolean}
		 */
		this.visible = true;

		/**
		 * X coordinate of the action on designer
		 *
		 * @type {number | undefined}
		 */
		this.x = undefined;

		/**
		 * Y coordinate of the action on designer
		 *
		 * @type {number | undefined}
		 */
		this.y = undefined;
	}

	/**
	 * Adds an allocator to the state
	 *
	 * @param {import('@knitiv/api-client-javascript').KNode} allocator KID of the role
	 * @returns {number} index of the new allocator
	 */
	addAllocator(allocator) {
		if (this.allocators.includes(allocator)) {
			throw new Error('Ce rôle/profil est déjà dans la liste');
		}
		return this.allocators.push(allocator) - 1;
	}

	/**
	 * Checks if an allocator exists
	 *
	 * @param {import('@knitiv/api-client-javascript').KNode} allocator KID of the allocator
	 * @returns {number|boolean} True if exists
	 */
	allocatorExists(allocator) {
		const key = this.allocators.indexOf(allocator);
		return key >= 0 ? key : false;
	}

	/**
	 * Deletes an allocator from the state
	 *
	 * @param {import('@knitiv/api-client-javascript').KNode} allocator KID of the role
	 * @private
	 */
	deleteAllocator(allocator) {
		let index = this.allocators.length - 1;
		while (index >= 0) {
			if (this.allocators[index] === allocator) {
				this.allocators.splice(index, 1);
			}
			index -= 1;
		}
	}
}
